const ObservationsToggleResolved = (options = {}) => {
  const _defaults = {
    toggle: 'js-toggle-resolved',
    toggleButton: '.c-observationsDashboard__toggleResolved',
    toggleButtonIcon: '.c-observationsDashboard__toggleResolvedIcon',
    expandedDisplay: 'flex',
    collapsedDisplay: 'none',
  };

  const settings = { ..._defaults, ...options };

  let toggle, toggleButton, toggleButtonIcon;

  const toggleObservations = () => {
    const currentDisplay = window.getComputedStyle(toggle).display;

    if (currentDisplay === settings.collapsedDisplay) {
      toggle.style.display = settings.expandedDisplay;
      toggleButtonIcon.style.transform = 'rotate(-90deg)';
    } else {
      toggle.style.display = settings.collapsedDisplay;
      toggleButtonIcon.style.transform = 'rotate(90deg)';
    }
  };

  // Public: Initialise module
  const init = () => {
    toggle = document.getElementById(settings.toggle);
    toggleButton = document.querySelector(settings.toggleButton);
    toggleButtonIcon = document.querySelector(settings.toggleButtonIcon);

    if (!toggle || !toggleButton || !toggleButtonIcon) return;

    toggleButton.addEventListener('click', toggleObservations);
  };

  // Public: Remove event listeners
  const destroy = () => {
    if (toggleButton) {
      toggleButton.removeEventListener('click', toggleObservations);
    }
  };

  // Public: Reinitialise the module (destroy then init)
  const reinit = () => {
    destroy();
    init();
  };

  return {
    init,
    destroy,
    reinit,
  };
};

export default ObservationsToggleResolved;
